import L from 'leaflet';

// Leaflet's vector renderers (L.Canvas / L.SVG, and kartvy's CappedCanvas) re-anchor their container on
// `moveend` (`_update`) but only re-project their shapes on `zoomend` (`_onZoomEnd`), assuming a moveend only
// comes once a zoom has ended. A moveend in the middle of a fly breaks that: on a phone, Leaflet's own
// window-resize handling (the keyboard closing after a search pick, or the address bar) fires one ~200 ms
// after the resize, often mid-fly. The renderers then re-anchored at the in-between zoom while their shapes
// were still projected for the start zoom, so the picked areas, the selection outline and the dimming were
// drawn in the wrong place (shifted, mis-scaled) until the fly's own zoomend re-projected them.
//
// Patched once for every renderer: `_update` re-projects first when the zoom has changed since the shapes
// were last projected. Ordinary pans and zooms are untouched (a zoom always ends with zoomend -> re-project
// before its moveend), so this only costs anything in that mid-animation case. Used by both views.
const proto = L.Renderer.prototype;
if (!proto.__projectedZoomGuard) {
    proto.__projectedZoomGuard = true;
    const { _update: update, _onZoomEnd: onZoomEnd, _reset: reset, onAdd } = proto;

    proto._onZoomEnd = function guardedOnZoomEnd(...args) {
        const result = onZoomEnd.apply(this, args);
        if (this._map) this.__projectedZoom = this._map.getZoom();
        return result;
    };
    // viewreset re-projects every shape itself (each layer's _reset), right after its own _update.
    proto._reset = function guardedReset(...args) {
        if (this._map) this.__projectedZoom = this._map.getZoom();
        return reset.apply(this, args);
    };
    proto.onAdd = function guardedOnAdd(...args) {
        const result = onAdd.apply(this, args);
        if (this._map) this.__projectedZoom = this._map.getZoom();
        return result;
    };
    proto._update = function guardedUpdate(...args) {
        const map = this._map;
        if (map && this.__projectedZoom != null && map.getZoom() !== this.__projectedZoom) {
            this._onZoomEnd(); // re-projects every shape at the current zoom (and records it)
        }
        return update.apply(this, args);
    };
}

export default proto.__projectedZoomGuard;
